export default __webpack_public_path__ + "static/media/postmates.ea36044f.png";